import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1d1f5f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mr-1 text-uppercase" }

import { ref, inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';


const __default__ = { name: 'CopiedButton' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['title', 'data', 'isCopied'],
  emits: ['copied'],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();



const show = ref(false);
const isTouch = inject('isTouch');

// копирование данных в буфер обмена
const copyToClipboard = async function (copiedText: string) {
    if (isTouch) show.value = true;
    await navigator.clipboard.writeText(copiedText);
    emit('copied', props.data);
    // скрытие подсказки через 2с
    setTimeout(() => (this.show = false), 2000);
};

const tooltipCapture = computed(() =>
    isTouch || props.isCopied ? t('commonUI.copiedButton.doneTitle') : t('commonUI.copiedButton.toDoTitle')
);

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(__props.data))),
    class: "btn"
  }, [
    _createElementVNode("strong", _hoisted_1, _toDisplayString(__props.title) + ": ", 1),
    _createTextVNode(" " + _toDisplayString(__props.data) + " ", 1),
    _createVNode(_component_v_tooltip, {
      activator: "parent",
      modelValue: show.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      location: "bottom"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(tooltipCapture)), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_ripple]
  ])
}
}

})